/** A column heading in the billing page's tables. */
export function HeaderCell({
  children,
  align,
  className = '',
}: {
  children: React.ReactNode
  align: 'left' | 'right'
  className?: string
}) {
  return (
    <th
      className={`pb-2 font-medium uppercase tracking-wider ${align === 'right' ? 'text-right' : 'text-left'} ${className}`}>
      {children}
    </th>
  )
}
